import { useReports } from "../../hooks/useReports";

const Laporan = () => {
    const { data: reports } = useReports();

    return (
        <>
            <div className="px-4 py-6 sm:px-6 lg:px-12 xl:px-20">
                <h2 className="text-xl font-bold mb-6 font-pontano">
                    Laporan Terkait Dana Pensiun Toyota Astra
                </h2>
                <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
                    {reports.length > 0 ? (
                        reports.map((report, index) => (
                            <div
                                key={index}
                                className="bg-white border border-gray-200 rounded-lg shadow hover:shadow-md transition duration-300 flex flex-col overflow-hidden"
                            >
                                <img
                                    src={report.thumbnail}
                                    alt={report.judul}
                                    className="w-full h-[300px] object-cover object-center"
                                />
                                <div className="flex flex-col p-4 justify-between grow">
                                    <div className="mb-4">
                                        <p className="text-sm text-[#EB0A1E] font-medium mb-1 font-inter">
                                            Laporan
                                        </p>
                                        <h3 className="text-base font-semibold leading-snug font-pontano">
                                            {report.judul}
                                        </h3>
                                    </div>
                                    <a
                                        href={report.dokumen}
                                        download
                                        className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#EB0A1E] text-white text-sm rounded-md hover:bg-red-700 transition self-start font-inter"
                                    >
                                        Download
                                        <img
                                            src="/images/asset/download.svg"
                                            alt="Download"
                                            className="w-4 h-4"
                                        />
                                    </a>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center py-10 text-gray-500">
                            Laporan belum tersedia.
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Laporan;
